import { connect } from 'react-redux'
import React from 'react'
import SignIn from '../pages/signin/SignIn'

const LogIn = ({ params, location }) => (
  <div className='s_p_a signin-container'>
    <SignIn action='login' viewParams={{ ...params, query: location.query }} />
  </div>
)

export default connect()(LogIn)



// WEBPACK FOOTER //
// ./src/routes/login.js